// src/pages/auth/VerifyOtpForgotPwd.jsx
import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import withRouter from "../../components/Common/withRouter";
import { useForgotPasswordVerifyOtp } from "../../api/auth";
import OtpInput from "react-otp-input";
import { Row, Col, Card, CardBody, Container, Button, Alert } from "reactstrap";
import { createSearchParams } from "react-router-dom";
import CustomHeader from "../../components/Auth/CustomHeader";

function VerifyOtpForgotPwd(props) {
  const { t } = props;

  // read query params (?email=...&token=...)
  const search = props?.router?.location?.search || "";
  const qp = useMemo(() => new URLSearchParams(search), [search]);
  const email = qp.get("email") || "";
  const token = qp.get("token") || "";

  const { mutate, isPending, isError, error } = useForgotPasswordVerifyOtp();
  const [otp, setOtp] = useState("");

  const handleVerify = () => {
    if (!email || !otp) return;
    mutate(
      { email, code: otp, token }, // adjust if your API expects different field names
      {
        onSuccess: () => {
          const search = createSearchParams({ email, code: otp }).toString();
          props.router.navigate({ pathname: "/reset-password", search: `?${search}` });
        }
      }
    );
  };

  return (
    <>
      <CustomHeader />

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-4">
                  <h4 className="mb-2">{t("verifyOtpHeading")}</h4>
                  <p className="text-muted mb-4">{t("verifyOtpSubheading", { email })}</p>

                  {isError && (
                    <Alert color="danger" className="mb-3">
                      {error?.message || t("verifyOtpGenericError")}
                    </Alert>
                  )}

                  <div className="d-flex justify-content-center mb-4">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      isInputNum
                      shouldAutoFocus
                      inputStyle={{
                        width: "40px",
                        height: "48px",
                        margin: "0 6px",
                        border: "1px solid #ced4da",
                        borderRadius: "6px",
                        fontSize: "20px",
                        textAlign: "center"
                      }}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <Button
                    color="secondary"
                    className="w-100"
                    onClick={handleVerify}
                    disabled={isPending || otp.length !== 6}
                  >
                    {isPending ? t("verifyOtpSubmitting") : t("verifyOtpSubmit")}
                  </Button>

                  <div className="text-center mt-3">
                    <small className="text-muted">
                      {t("verifyOtpDidntGet")}{" "}
                      <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={() =>
                          props.router.navigate(
                            `/forgot-password?email=${encodeURIComponent(email)}`
                          )
                        }
                      >
                        {t("verifyOtpResend")}
                      </button>
                    </small>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default withRouter(withTranslation()(VerifyOtpForgotPwd));
